/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Date
 * @static
 * @hideconstructor
 */
var monthNames = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
var oneMinute = 60000;
var oneHour = 60 * oneMinute;
var oneDay = 24 * oneHour;
/**
 * Convert Date object to large format string
 * @method toLargeFormat
 * @name Jobin.Date.toLargeFormat
 * @param {date} date
 * @returns {string} Large format date string.
 */

export function toLargeFormat(date) {
  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();
  return {
    status: "ok",
    result: day + " " + monthNames[monthIndex] + " " + year
  };
}
/**
 * Convert Date object to sort format string
 * @method toSortFormat
 * @name Jobin.Date.toSortFormat
 * @param {date} date
 * @returns {string} Sort format date string.
 */

export function toSortFormat(date) {
  var day = ("0" + date.getDate()).slice(-2);
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var year = date.getFullYear();
  return {
    status: "ok",
    result: day + "/" + month + "/" + year
  };
}
/**
 * Convert Date object to chat format string
 * @method toChatFormat
 * @name Jobin.Date.toChatFormat
 * @param {date} date
 * @returns {string} Chat format date string.
 */

export function toChatFormat(date) {
  var currentDate = new Date();
  var result = Math.round((currentDate - date) / oneDay);
  if (result == 0) {
    var minutes = ("0" + date.getMinutes()).slice(-2);
    var hour = ("0" + date.getHours()).slice(-2);
    return {
      status: "ok",
      result: hour + ":" + minutes
    };
  } else {
    var day = ("0" + (date.getDate() + 1)).slice(-2);
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var year = date.getFullYear();
    return {
      status: "ok",
      result: day + "/" + month + "/" + year
    };
  }
}
/**
 * Days between two days
 * @method daysSince
 * @name Jobin.Date.daysSince
 * @param {date} date
 * @returns {number} Days between two days.
 */

export function daysSince(date) {
  var currentDate = new Date();
  return {
    status: "ok",
    result: Math.round(Math.abs((currentDate.getTime() - date.getTime()) / oneDay))
  };
}
/**
 * Fomats a date relative to current date
 * @param {Date} date date to format
 */

export function formatRelative(date) {
  var diff = new Date().getTime() - date.getTime();
  var text = diff < oneMinute ? "menos de un minuto" : diff < 2 * oneMinute ? "hace 1 minuto" : diff < oneHour ? "hace ".concat(Math.floor(diff / oneMinute), " minutos") : diff < 2 * oneHour ? "hace 1 hora" : diff < oneDay ? "hace ".concat(Math.floor(diff / oneHour), " horas") : diff < 2 * oneDay ? "hace 1 d\xEDa" : "hace ".concat(Math.floor(diff / oneDay), " d\xEDas");
  return {
    status: "ok",
    result: text
  };
}